import { FB_LOGIN_CONFIG_ID } from './config';

export interface FacebookAuthStatus {
  isConnected: boolean;
  accessToken: string | null;
}

export function toAuthStatus(
  response: facebook.StatusResponse
): FacebookAuthStatus {
  return {
    isConnected: response.status === 'connected',
    accessToken: response.authResponse?.accessToken ?? null,
  };
}

export function getLoginStatus(): Promise<facebook.StatusResponse> {
  return new Promise((resolve, reject) => {
    try {
      globalThis.FB.getLoginStatus((response) => {
        resolve(response);
      });
    } catch {
      reject(new Error('Failed to retrieve Facebook login status'));
    }
  });
}

export function login(): Promise<facebook.StatusResponse> {
  return new Promise((resolve, reject) => {
    try {
      globalThis.FB.login(
        (response) => {
          resolve(response);
        },
        { config_id: FB_LOGIN_CONFIG_ID }
      );
    } catch {
      reject(new Error('Failed to open Facebook login'));
    }
  });
}

export async function logout(): Promise<void> {
  const status = await getLoginStatus();

  if (status.status !== 'connected') {
    return;
  }

  return new Promise((resolve, reject) => {
    try {
      globalThis.FB.logout(() => {
        resolve();
      });
    } catch {
      reject(new Error('Failed to logout from Facebook'));
    }
  });
}
